














import {Component, Prop, Vue} from "vue-property-decorator";
import {IRangeIntRule} from "@/modules/Segmentation/models/SegmentationRules";
import RangeSelectIntForm from "@/components/RangeSelectIntForm.vue";

@Component({
    components: {RangeSelectIntForm}
})
export default class RangeSelectIntFormSwitchable extends Vue {
    @Prop() public readonly value!: IRangeIntRule;

    get isActive(): boolean {
        return this.value.to !== null || this.value.from !== null;
    }

    set isActive(val: boolean) {
        if (!val) {
            this.value.from = null;
            this.value.to = null;
        } else {
            this.value.from = 0;
        }
    }

    get model(): IRangeIntRule {
        return this.value;
    }

    set model(val: IRangeIntRule) {
        this.$emit("input", val);
    }
}
